import logo from '@/components/logo.webp'

const APP_NAME =
  (import.meta.env.VITE_APP_NAME as string | undefined) ?? 'LingoChatAI'

export default function FunnelLogo() {
  return (
    <div className="flex items-center gap-2">
      <img alt="" className="h-7 w-auto" src={logo} />

      <span className="text-hw-ink text-lg font-bold tracking-tight">
        {APP_NAME}
      </span>
    </div>
  )
}
